<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<div
					class="layout-block vertical"
					[style.align-items]="'inherit'"
					[style.gap]="'1em'"
				>
					<ng-container *ngIf="screen.timelineChart">
						<div
							*ngIf="(screen.timelineChart) as $config"
							style="height: auto; width: 99%"
						>
							<canvas
								baseChart
								class="chart"
								[data]="$config.data"
								[type]="$config.type"
								[options]="$config.options"
								[plugins]="$config.plugins"
							>
							</canvas>
						</div>
					</ng-container>

					<Toolbox-GoalSettingGoalsInclude
						[$formDirective]="$formDirective"
						[$disabled]="$disabled"
						[$ignoreValidations]="$ignoreValidations"
						[gs]="screen.gs"
						[goals]="screen.gs.developmentGoals"
						[goalType]="This.GoalSettingGoalType.DevelopmentGoal"
						[viewMode]="screen.viewMode"
						[columnVisibility]="screen.columnVisibility"
						[validateMinGoals]="1"
					>
					</Toolbox-GoalSettingGoalsInclude>
					<Toolbox-GoalSettingGoalsInclude
						[$formDirective]="$formDirective"
						[$disabled]="$disabled"
						[$ignoreValidations]="$ignoreValidations"
						[gs]="screen.gs"
						[goals]="screen.gs.performanceGoals"
						[goalType]="This.GoalSettingGoalType.PerformanceGoal"
						[viewMode]="screen.viewMode"
						[columnVisibility]="screen.columnVisibility"
						[validateMinGoals]=""
					>
					</Toolbox-GoalSettingGoalsInclude>
					<ng-container *ngIf="screen.columnVisibility.showSelfReview"
						><Toolbox-GoalSettingSelfReviewAnswersInclude
							[$formDirective]="$formDirective"
							[$disabled]="$disabled"
							[$ignoreValidations]="$ignoreValidations"
							[gs]="screen.gs"
							[viewMode]="screen.viewMode"
							[columnVisibility]="screen.columnVisibility"
						>
						</Toolbox-GoalSettingSelfReviewAnswersInclude
					></ng-container>

					<ng-container
						*ngIf="screen.columnVisibility.showManagerReview && screen.futureColumnVisibility"
						><Toolbox-GoalSettingGoalsInclude
							[$formDirective]="$formDirective"
							[$disabled]="$disabled"
							[$ignoreValidations]="$ignoreValidations"
							[gs]="screen.gs"
							[goals]="screen.gs.futureDevelopmentGoals"
							[goalType]="This.GoalSettingGoalType.FutureDevelopmentGoal"
							[viewMode]="screen.viewMode"
							[columnVisibility]="screen.futureColumnVisibility"
							[validateMinGoals]=""
						>
						</Toolbox-GoalSettingGoalsInclude>
						<Toolbox-GoalSettingGoalsInclude
							[$formDirective]="$formDirective"
							[$disabled]="$disabled"
							[$ignoreValidations]="$ignoreValidations"
							[gs]="screen.gs"
							[goals]="screen.gs.futurePerformanceGoals"
							[goalType]="This.GoalSettingGoalType.FuturePerformanceGoal"
							[viewMode]="screen.viewMode"
							[columnVisibility]="screen.futureColumnVisibility"
							[validateMinGoals]=""
						>
						</Toolbox-GoalSettingGoalsInclude
					></ng-container>

					<mat-card>
						<mat-card-header>
							<mat-card-title
								><span
									[innerHtml]="'Attachments' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></mat-card-title>
						</mat-card-header>

						<mat-card-content>
							<div
								class="layout-block vertical"
								[style.align-items]="'inherit'"
								[style.gap]="'1em'"
							>
								<ng-container *ngIf="screen.gs.attachments.length; else else83"
									><lowgile-table
										#datatable_74
										[dataSignal]="_DataTableBlock_collectionCodeSignal_74(datatable_74, { app, screen, $pathSegments, $disabled })"
										[trackBy]="trackByAutomatic"
										[columns]="_DataTableBlock_columns_74(screen)"
										[showSettings]="false"
										[userDefinedConfiguration]="undefined"
										[usePaging]="false"
										[pageSize]="99"
										[pageSizeOptions]="[10, 20, 50]"
										[useGlobalFilter]="false"
										[debouncingDelay]="250"
										[stickyHeader]="true"
										[additionalFindOptions]="_DataTableBlock_additionalFindOptions_74({ app, screen, $pathSegments, $disabled })"
										[additionalHeaderRows]="[]"
										[additionalFooterRows]="[]"
										[allClasses]="$Modules"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[surroundingScope]="$scope"
										#$table_74="lowgileTable"
									>
										<ng-container [lowgile-column]="'file'">
											<th mat-header-cell *matHeaderCellDef>
												<span
													[innerHtml]="'File' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</th>
											<td
												mat-cell
												*matCellDef="let attachment; let attachmentIndex = index"
												[attr.data-label]="'File'"
											>
												<ng-container
													*lowgileScope="attachment; as: 'attachment'; let $scope"
												>
													<ng-container
														*lowgileScope="attachmentIndex; as: 'attachmentIndex'; let $scope"
													>
														<a
															class="has-click-handler"
															(click)="handler_LinkBlock_80_click_$adhoc_0($event, { attachment, attachmentIndex, $disabled: $disabled })"
														>
															<span
																[innerHtml]="attachment.fileName | escapeHtml: 'none' | replaceNewlines: 'span'"
															></span>
														</a>
													</ng-container>
												</ng-container>
											</td>
										</ng-container>
										<ng-container [lowgile-column]="('file') + '$$filter'">
											<th mat-header-cell *matHeaderCellDef></th>
										</ng-container>

										<ng-container [lowgile-column]="'owner'">
											<th mat-header-cell *matHeaderCellDef>
												<span
													[innerHtml]="'Uploaded by' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</th>
											<td
												mat-cell
												*matCellDef="let attachment; let attachmentIndex = index"
												[attr.data-label]="'Uploaded by'"
											>
												<ng-container
													*lowgileScope="attachment; as: 'attachment'; let $scope"
												>
													<ng-container
														*lowgileScope="attachmentIndex; as: 'attachmentIndex'; let $scope"
													>
														<span
															[innerHtml]="_DataTableColumnBlock_cellText_76({ app, screen, $pathSegments, $disabled, attachment, attachmentIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</ng-container>
												</ng-container>
											</td>
										</ng-container>
										<ng-container [lowgile-column]="('owner') + '$$filter'">
											<th mat-header-cell *matHeaderCellDef></th>
										</ng-container>

										<ng-container [lowgile-column]="'column_75'">
											<th mat-header-cell *matHeaderCellDef>
												<span
													[innerHtml]="'Actions' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
											</th>
											<td
												mat-cell
												*matCellDef="let attachment; let attachmentIndex = index"
												[attr.data-label]="'Actions'"
											>
												<ng-container
													*lowgileScope="attachment; as: 'attachment'; let $scope"
												>
													<ng-container
														*lowgileScope="attachmentIndex; as: 'attachmentIndex'; let $scope"
													>
														<ng-container
															*ngIf="!$disabled && (attachment.owner?.userId == Sys.User.currentUser.id || screen.viewMode.isHr)"
															><button
																mat-icon-button
																mat-small-icon-button
																class="has-click-handler"
																color="warn"
																(click)="handler_ButtonBlock_68_click_$adhoc_0($event, { attachment, attachmentIndex, $disabled: $disabled })"
																[disabled]="$disabled"
															>
																<mat-icon>{{'delete'}}</mat-icon>
															</button></ng-container
														>
													</ng-container>
												</ng-container>
											</td>
										</ng-container>
										<ng-container [lowgile-column]="('column_75') + '$$filter'">
											<th mat-header-cell *matHeaderCellDef></th>
										</ng-container> </lowgile-table
								></ng-container>
								<ng-template #else83>
									<span
										style="font-style: italic"
										[innerHtml]="'(no attachments uploaded)' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
								</ng-template>
								<ng-container *ngIf="!$disabled"
									><div
										class="layout-block"
										[style.align-items]="'inherit'"
										[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.gap]="'1em'"
									>
										<app-file-upload
											class="has-filesSelected-handler"
											(filesSelected)="handler_FileUploadBlock_84_filesSelected_$adhoc_0($event, { $disabled: $disabled })"
											[multiple]="false"
											[allowedMimeTypes]="'*'"
											[disabled]="$disabled"
											displayStyle="dropZone"
											[uploadToServer]="false"
											color="basic"
										>
											<span
												[innerHtml]="'Drop files here to upload attachment' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</app-file-upload></div
								></ng-container>
							</div>
						</mat-card-content>
					</mat-card>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
